import React, { useCallback, useEffect, useState } from 'react';
import { Loader2, Megaphone, Plus } from 'lucide-react';
import { toast } from 'sonner';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { TeamCampaignCard } from './TeamCampaignCard';
import { CreativeEditorDialog } from './CreativeEditorDialog';
import { adsApprovalsAPI } from '../lib/api';

const OwnerSelect = () => {
  const [url, setUrl] = useState('');
  useEffect(() => { adsApprovalsAPI.getSettings().then((s) => setUrl(s.changes_discord_webhook_url || '')).catch(() => {}); }, []);
  const save = () => adsApprovalsAPI.saveDiscord(url).then(() => toast.success('Guardado')).catch((er) => toast.error(er.message));
  return (
    <div className="text-xs text-muted-foreground flex items-center gap-2 flex-wrap" data-testid="ads-changes-discord">
      <span>Cambios pedidos por el cliente → solo Marta (portal + Discord). Tu canal privado de Discord (uno para todos los clientes; no es el canal de ads del cliente):</span>
      <Input value={url} onChange={(e) => setUrl(e.target.value)} placeholder="https://discord.com/api/webhooks/..." className="h-8 w-72 text-xs" data-testid="ads-changes-discord-input" />
      <Button size="sm" variant="outline" onClick={save} data-testid="ads-changes-discord-save">Guardar</Button>
    </div>
  );
};

export const AdsApprovalsManager = ({ clientId }) => {
  const [tree, setTree] = useState(null);
  const [nombre, setNombre] = useState('');
  const [editor, setEditor] = useState(null);

  const load = useCallback(() => adsApprovalsAPI.tree(clientId).then((t) => setTree(t.campaigns)).catch((e) => toast.error(e.message)), [clientId]);
  useEffect(() => { setTree(null); load(); }, [load]);

  const create = async () => {
    if (!nombre.trim()) return;
    try {
      const c = await adsApprovalsAPI.createCampaign(clientId, { nombre: nombre.trim() });
      await adsApprovalsAPI.createBatch(c.id);
      setNombre('');
      load();
    } catch (e) { toast.error(e.message); }
  };

  return (
    <Card data-testid="ads-approvals-manager">
      <CardHeader className="flex flex-row items-center justify-between space-y-0 flex-wrap gap-2">
        <CardTitle className="flex items-center gap-2"><Megaphone className="w-5 h-5 text-primary" />Aprobación de creativos de Ads</CardTitle>
        <OwnerSelect />
      </CardHeader>
      <CardContent className="space-y-4">
        <p className="text-sm text-muted-foreground">Campaña → Tanda → Creativo. Crea los creativos en una tanda y envíala: el cliente los aprueba uno a uno en su portal (Aprobaciones) y después los consulta en Campañas.</p>
        <div className="flex gap-2">
          <Input value={nombre} onChange={(e) => setNombre(e.target.value)} onKeyDown={(e) => e.key === 'Enter' && create()} placeholder="Nombre de la nueva campaña" data-testid="ads-new-campaign-input" />
          <Button onClick={create} disabled={!nombre.trim()} data-testid="ads-new-campaign-btn"><Plus className="w-4 h-4 mr-1" />Nueva campaña</Button>
        </div>
        {tree === null ? <div className="py-10 flex justify-center"><Loader2 className="w-6 h-6 animate-spin" /></div>
          : !tree.length ? <p className="text-sm text-muted-foreground text-center py-8" data-testid="ads-approvals-empty">Aún no hay campañas para aprobar.</p>
            : tree.map((c) => <TeamCampaignCard key={c.id} camp={c} onChanged={load}
              onEdit={(cr) => setEditor({ creative: cr })} onNew={(batchId) => setEditor({ batchId })} />)}
      </CardContent>
      <CreativeEditorDialog open={!!editor} batchId={editor?.batchId} creative={editor?.creative} onClose={() => setEditor(null)} onSaved={load} />
    </Card>
  );
};
